
import Minimize from "../../../assets/filled/Minimize.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MinimizeIcon({ className, dataTestid = "MinimizeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Minimize data-testid={dataTestid} className={classes} {...rest} />
  );
}
